module.exports = __webpack_public_path__ + "img/calendar.9b2d1e95.svg";